export default __webpack_public_path__ + "static/media/logo.5b44a9c4.svg";